/**
 * @generated SignedSource<<2da22609f7e7e88e5de3bc1d1336326b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type DashboardFlightsCard_settings$data = {
  readonly " $fragmentSpreads": FragmentRefs<"DashboardFlightsCardUpdateStatus_settings">;
  readonly " $fragmentType": "DashboardFlightsCard_settings";
};
export type DashboardFlightsCard_settings$key = {
  readonly " $data"?: DashboardFlightsCard_settings$data;
  readonly " $fragmentSpreads": FragmentRefs<"DashboardFlightsCard_settings">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "DashboardFlightsCard_settings",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "DashboardFlightsCardUpdateStatus_settings"
    }
  ],
  "type": "Settings",
  "abstractKey": null
};

(node as any).hash = "6247a683b21e1b9b1776d74b1672429d";

export default node;
